export default __webpack_public_path__ + "ed6c47bd94b15aa8495616431eb36ec6.svg";